/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import OurServices from './OurServices';
import Departments from './Departments';
import ShowSubmenus from './ShowSubmenus';

const MenuMobile = (props) => {
  const { openMenu } = props;
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [department, setDepartment] = useState({});
  const [changeId, setChangeId] = useState('slide');

  function handleClick(departmentData) {
    showSubMenu ? setShowSubMenu(false) : setShowSubMenu(true);
    setDepartment(departmentData);
  }

  function helloUser(user) {
    if (!user) return <a style={{ color: 'white' }} href="https://www.alobebe.com.br/painel">Entre ou cadastre-se</a>;
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <a style={{ color: 'white' }} href="https://www.alobebe.com.br/painel">
          Olá,
          {' '}
          <b style={{ textDecoration: 'underline' }}>
            {user}
          </b>
        </a>

      </div>
    );
  }

  const renderSubMenu = (
    <div className="sub-menu-div" id={changeId}>
      <div>
        <ShowSubmenus department={department} handleClick={handleClick} setChangeId={setChangeId} />
      </div>
    </div>
  );

  const renderMainMenu = (
    <div>
      <p className="green-menu user">
        {helloUser(localStorage.getItem('username'))}
        <CloseIcon className="close-icon" sx={{ fontSize: 35 }} onClick={() => openMenu()} />
      </p>
      <Departments handleClick={handleClick} openMenu={openMenu} />
      <OurServices />
    </div>
  );

  return (
    <div className="menu-mobile">
      { renderMainMenu }
      { showSubMenu ? renderSubMenu : null }
    </div>
  );
};

MenuMobile.propTypes = {
  openMenu: PropTypes.func,
  departmentData: PropTypes.object,
  showIcon: PropTypes.bool,
}.isRequired;

export default MenuMobile;
